{
  "hero": {
    "title": "قصص تستحق أن تُسمع",
    "subtitle": "صحافة مستقلة بالفرنسية والإنجليزية والعربية"
  },
  "latest": {
    "title": "آخر القصص",
    "viewAll": "عرض جميع المقالات",
    "backHome": "العودة للصفحة الرئيسية",
    "emptyTitle": "قصص في الطريق",
    "emptyText": "نحن نجهّز أولى قصصنا — عد قريباً."
  },
  "categories": {
    "all": "الكل",
    "investigation": "تحقيقات",
    "culture": "ثقافة",
    "opinion": "رأي",
    "features": "تقارير",
    "video": "فيديو"
  },
  "newsletter": {
    "title": "ابق على اطلاع",
    "description": "احصل على أحدث القصص في بريدك الإلكتروني.",
    "placeholder": "بريدك الإلكتروني",
    "cta": "اشتراك",
    "success": "شكراً لاشتراكك!",
    "error": "فشل الاشتراك. يرجى المحاولة مرة أخرى."
  },
  "about": {
    "title": "حول Beyond Silence",
    "p1": "Beyond Silence هي منصة صحفية مستقلة ثلاثية اللغة تنشر بالفرنسية والإنجليزية والعربية. نؤمن بأن قصص كل مجتمع تستحق أن تُسمع — لا أن تُسكت، ولا أن تُتجاهل، ولا أن تضيع في الترجمة.",
    "p2": "يعمل فريقنا من الصحفيين والمحررين والمساهمين عبر الحدود ليقدم لكم تحقيقات وتقارير ومقالات رأي وتقارير فيديو تتحدى الوضع الراهن وتضخم الأصوات غير الممثلة.",
    "p3": "يتم تمويل Beyond Silence من قبل قراء مثلك. لا نستخدم نظام حظر المحتوى ولا نطلب اشتراكًا. إذا كنت تقدر عملنا، فكر في دعمنا عبر Buy Me a Coffee — كل مساهمة تساعدنا على مواصلة العمل.",
    "contactTitle": "تواصل معنا",
    "contactDesc": "هل لديك قصة أو ترغب في التعاون أو الانضمام إلى فريقنا؟ راسلنا على contact@beyondsilence.fr. نقرأ كل رسالة."
  },
  "contact": {
    "title": "اتصل بنا",
    "description": "أسئلة، أو معلومات صحفية، أو رغبة في التعاون؟ اكتب إلينا — نقرأ كل رسالة."
  }
}
